import { useDispatch, useSelector } from "react-redux";
import lang from "../utils/langConstants";
import { useRef, useState } from "react";
import { GEMINI_API_KEY, API_OPTIONS } from "../utils/constants";
import { addGptMovieResult } from "../utils/gptSlice";
import { GoogleGenerativeAI } from "@google/generative-ai";
import { displayLoader } from "../utils/configSlice";
import Loader from "./Loader";
import axios from "axios";

const GptSearchBar = () => {
  const dispatch = useDispatch();
  const langKey = useSelector((store) => store.config.lang);
  const loader = useSelector((store) => store.config.loader);

  const searchText = useRef(null);
  const [gptErrorMessage, setGptErrorMessage] = useState(null);

  const genAI = new GoogleGenerativeAI(GEMINI_API_KEY);
  //Search movie in TMDB
  const searchMovieTMDB = async (gptMovieName) => {
    const response = await axios.get(
      "https://api.themoviedb.org/3/search/movie?query=" +
        gptMovieName +
        "&include_adult=false&language=en-US&page=1",
      API_OPTIONS,
    );

    const json = await response.data;

    return json.results;
  };

  const handleGptSearchClick = async () => {
    const queryText = searchText.current.value.trim();
    // console.log("q", queryText)
    if (queryText === "") {
      setGptErrorMessage(
        "It seems like you haven't entered the search, please try again",
      );
      return;
    } else {
      setGptErrorMessage(null);
    }

    const gptQuery =
      "Act as a movie reccomendation system for the query: " +
      queryText +
      "only give me name of 5 movies, names should be in english seperated by percentage sign % and like the example result given ahead. Example Result: The Avengers%Guardians of the Galaxy, Vol. 2%Harry Potter and the Sorcerer's Stone%Koi Mil Gaya%Birds of Prey (and the Fantabulous Emancipation of One Harley Quinn) ";

    //Make an API call to GPT API and get Movie Reccs
    try {
      dispatch(displayLoader(true));

      const model = genAI.getGenerativeModel({ model: "gemini-2.5-flash" });

      const result = await model.generateContent(gptQuery);

      const response = await result.response;
      const text = response.text();

      const gptMovieList = text;

      const gptMovieListArray = gptMovieList
        ?.split("%")
        .map((movie) => movie.trim());

      //.trim() removes if any whitespaces in each element
      // Convert the array to a Set to remove duplicates
      let uniqueMoviesSet = new Set(gptMovieListArray);

      // Convert the Set back to an array (if needed)
      let uniqueMoviesArray = Array.from(uniqueMoviesSet);
      // console.log(gptMovieListArray)

      // console.log(uniqueMoviesArray)

      //Need to search movie in TMDB API
      // [Promise, Promise, Promise, Promise, Promise]
      const promiseArray = uniqueMoviesArray.map((movie) =>
        searchMovieTMDB(movie),
      );

      const tmdbResults = await Promise.all(promiseArray);
      //console.log(uniqueMoviesArray,tmdbResults)

      dispatch(
        addGptMovieResult({
          gptMovieNames: uniqueMoviesArray,
          tmdbMovieList: tmdbResults,
        }),
      );

      dispatch(displayLoader(false));
    } catch (e) {
      // TODO:Error Page
      setGptErrorMessage(
        "Unable to fetch response from the Gemini. Please try again later.",
      );
    }
  };

  return (
    <div className=" flex flex-col w-full ">
      <div className="w-full flex items-center flex-col">
        <form
          action=""
          className="w-full md:w-1/2 rounded-md bg-[#060730] grid grid-cols-12"
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <input
            ref={searchText}
            type="text"
            placeholder={lang[langKey].gptSearchPlaceholder}
            className="col-span-9 px-2 py-3 m-3 md:m-4 rounded-lg "
          />

          <button
            className="col-span-3 md:px-5 py-2 my-3 mr-3 md:my-4 md:mr-4 font-bold bg-white text-[#060730] rounded-lg text-xl hover:bg-blue-700 hover:text-white ease-in-out duration-500"
            onClick={handleGptSearchClick}
          >
            {loader ? (
              <>
                <Loader />
              </>
            ) : (
              lang[langKey].search
            )}
          </button>
        </form>
        {
          //Error Message
          gptErrorMessage === null ? (
            ""
          ) : (
            <p className="text-red-600 w-1/2  rounded-lg p-2 bg-[#361828]">
              {gptErrorMessage}
            </p>
          )
        }
      </div>
    </div>
  );
};

export default GptSearchBar;
